import React from "react";
import { Box, BoxProps } from "@mui/material";
import { ThemeProvider, Theme, StyledEngineProvider } from "@mui/material/styles";
import createStyles from "@mui/styles/createStyles";
import makeStyles from "@mui/styles/makeStyles";
import { verbalTheme } from "../../components/layout/themes/verbal.theme";
import { publicTheme } from "../../components/layout/themes/public.theme";

declare module "@mui/styles/defaultTheme" {
    // eslint-disable-next-line @typescript-eslint/no-empty-interface
    interface DefaultTheme extends Theme {}
}

export enum CollectionCardType {
    Shade1 = "Shade1",
    Shade2 = "Shade2",
    Shade3 = "Shade3",
}

const LightTheme: React.FC<{ children?: React.ReactNode }> = ({ children }) => (
    <StyledEngineProvider injectFirst>
        <ThemeProvider theme={verbalTheme}>{children}</ThemeProvider>
    </StyledEngineProvider>
);
const DarkTheme: React.FC<{ children?: React.ReactNode }> = ({ children }) => (
    <StyledEngineProvider injectFirst>
        <ThemeProvider theme={publicTheme}>{children}</ThemeProvider>
    </StyledEngineProvider>
);
const DarkishTheme: React.FC<{ children?: React.ReactNode }> = ({ children }) => (
    <StyledEngineProvider injectFirst>
        <ThemeProvider
            theme={{
                ...publicTheme,
                palette: {
                    ...publicTheme.palette,
                    background: { ...publicTheme.palette.background, paper: publicTheme.palette.secondary.light },
                },
            }}
        >
            {children}
        </ThemeProvider>
    </StyledEngineProvider>
);
const LightishTheme: React.FC<{ children?: React.ReactNode }> = ({ children }) => (
    <StyledEngineProvider injectFirst>
        <ThemeProvider
            theme={{
                ...verbalTheme,
                palette: {
                    ...verbalTheme.palette,
                    background: { ...verbalTheme.palette.background, paper: verbalTheme.palette.secondaryShade.main },
                },
            }}
        >
            {children}
        </ThemeProvider>
    </StyledEngineProvider>
);

const useStyles = makeStyles(
    createStyles({
        card: {
            backgroundColor: verbalTheme.palette.common.white,
            "&:hover": {
                cursor: "pointer",
            },
        },
    }),
);

type CollectionCardProps = BoxProps & {
    type?: CollectionCardType;
    children: React.ReactNode;
    padded?: boolean;
};

export const CollectionCard: React.FC<CollectionCardProps> = (props: CollectionCardProps): JSX.Element => {
    const { type, children, padded = true, ...rest } = props;

    const classes = useStyles();

    let ThemeComponent: React.FC<{ children?: React.ReactNode }>;
    switch (type) {
        // Light
        case CollectionCardType.Shade1:
            ThemeComponent = LightishTheme;
            break;
        // darkish
        case CollectionCardType.Shade2:
            ThemeComponent = DarkishTheme;
            break;
        /// v dark
        case CollectionCardType.Shade3:
            ThemeComponent = DarkTheme;
            break;
        default:
            ThemeComponent = LightTheme;
            break;
    }

    return (
        <ThemeComponent>
            <Box p={padded ? 3 : 0} className={classes.card} {...rest}>
                {children}
            </Box>
        </ThemeComponent>
    );
};
